import type {ReactElement} from 'react';
import React, { useEffect} from 'react';
import type { BaseMasonryGridProps} from '@Components/base-masonry-grid';
import {BaseMasonryGrid} from '@Components/base-masonry-grid';
import {useAppDispatch} from '@/hooks';
import {addGrid} from '../base-grid';
import type {GridItemStorage} from '../base-grid/components/grid-item';

export interface MasonryGridProps extends BaseMasonryGridProps {
  items?: Array<GridItemStorage>;
}

function MasonryGrid({items = [], ...props}: MasonryGridProps): ReactElement {
  const dispatch = useAppDispatch();
  const selectionGroupId = props.gridSelectionGroupId ?? props.gridId;

  useEffect(() => {
    dispatch(
      addGrid({
        id: props.gridId,
        maxSelectionNumber: props.maxSelectionNumber,
        gridSelectionGroupId: selectionGroupId,
        items,
      })
    );
  }, []);

  return <BaseMasonryGrid {...props} gridSelectionGroupId={selectionGroupId} />;
}

export default MasonryGrid;
